import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ArticleCard } from "@/components/ArticleCard";
import { motion } from "framer-motion";

export default function InsightsList() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {}).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="insights-page">
      <Seo
        title="Insights & Articles"
        description="Practical thought leadership on HR governance, people risk, case perspectives and regulatory updates from Irina Ishik — advising boards and executives across the UAE, Europe, Turkey and the Middle East."
        path="/insights"
      />
      <Header />
      <main className="pt-36 pb-32 px-6 md:px-12 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Insights &amp; Articles</p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
            className="font-serif font-light text-5xl md:text-7xl tracking-tight max-w-4xl mb-6"
          >
            Thought leadership on HR governance &amp; people risk.
          </motion.h1>
          <p className="text-muted2 max-w-xl mb-20 leading-relaxed">
            Practical articles, case perspectives and regulatory reflections drawn from two decades advising boards
            and executives across regulated, multi-jurisdiction markets.
          </p>

          {loading ? (
            <p className="text-muted2 font-mono text-sm">Loading…</p>
          ) : articles.length === 0 ? (
            <p className="text-muted2 font-mono text-sm" data-testid="insights-empty">No articles published yet.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
              {articles.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
